/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': 'หมายเลขบัญชียังไม่ได้ลงทะเบียน โปรดไปลงทะเบียนก่อนแล้วจึงเข้าสู่ระบบ',
    'no_zone_code': '(ไม่ต้องใช้หมายเลขประเทศ)',
    '授权校验失败，请刷新页面并重试。': 'Authorization verification failed. Please refresh the page and try again.',
    'onlineService': 'Online service',
    'standardExpress': 'การจัดส่งแบบมาตรฐาน',
    'economyExpress': 'การจัดส่่งแบบประหยัด',
    'eParcel': 'e-parcel/ e-parcel+',
    'overseasFulfilment': '\nการจัดส่งอีคอมเมิร์ซระหว่างประเทศ',
    'warehouse': 'คลังสินค้า',
    'pleaseAgreePolicy': 'Please read and agree to the Privacy Policy',
    'pleaseAgreeToScan': 'โปรดอ่านและยอมรับข้อตกลงทางด้านขวาก่อน',
    'heavyFreight': 'การขนส่งสินค้าหนัก',
    '验证码接收方式': 'วิธีการรับรหัสยืนยัน',
    'cancelTips': 'โปรดอ่านและยืนยันการยกเลิกบัญชี',
    'confirmCancel': 'ยืนยันการออกจากระบบ',
    'verificationCodeError': 'ข้อผิดพลาด CAPTCHA, รับ CAPTCHA อีกครั้ง!',
    'clickGoDirectly': '(คลิกตรงไป)',
    'repeatTips': 'บัญชีของคุณมีปัญหาซ้ำกัน โปรดไปที่ <span class="mode">เลือกวิธีการเข้าสู่ระบบ',
    'repeatTips1': 'หมายเลขโทรศัพท์มือถือของคุณมีปัญหาซ้ำกัน โปรดไปที่ <span class="mode">เข้าสู่ระบบหลังจากเลือกรหัสพื้นที่</span> จากนั้น {count}seconds จะข้ามไปโดยอัตโนมัติ',
    'goOldLogin': 'เข้าสู่ระบบรุ่นเก่า',
    'goNewLogin': 'เข้าสู่ระบบเวอร์ชั่นใหม่',
    'siteTips': 'เคล็ดลับ หน้ามาตรฐาน',
    'siteGo': 'ไปหน้ามาตรฐาน',
    'loginLoading': 'เข้าสู่ระบบใหม่โดยอัตโนมัติโปรดรอสักครู่',
    'sfExpress': 'ลิขสิทธิ์ เอสเอฟ เอ็กซ์เพรส เลขที่ 08034243 มณฑลกวางตุ้ง',
    'sgSfExpress': 'ลิขสิทธิ์ เอสเอฟ เอ็กซ์เพรส เลขที่ 08034243 มณฑลกวางตุ้ง',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': 'ศูนย์บริการรับรองมาตรฐานสากล',
    'jumpError': 'ที่อยู่ Jump ไม่ถูกต้องตามกฎหมาย',
    'tips': 'คำแนะนำ',
    'tips1': 'คำแนะนำ',
    'confirm': 'ยืนยัน',
    'agreeWith': 'I have read and agree to the ',
    'agreeAndContinue': 'ฉันได้อ่านและยอมรับ นโยบายความเป็นส่วนตัว',
    'agreeService': 'ฉันได้อ่านและยอมรับ เงื่อนไขการให้บริการ',
    'agreeUserAgreement': 'ฉันได้อ่านและยอมรับข้อตกลงผู้ใช้',
    'agreeEpesAcceptableUse': 'ฉันได้อ่านและยอมรับ นโยบายการใช้บริการ SF Korea ERP',
    'define': 'ยืนยัน',
    'cancel': 'ยกเลิก',
    'yes': 'ใช่',
    'no': 'ไม่',
    'sendAgain': 'ส่งอีกครั้ง',
    'second': 'วินาที',
    'iknow': 'เข้าใจแล้ว',
    'country': 'ประเทศ/เขต',
    'tel': 'หมายเลขโทรศัพท์',
    'email': 'อีเมล',
    'telNumber': 'หมายเลขโทรศัพท์มือถือ',
    'verifyCode': 'รหัสการตรวจสอบ',
    'sendVerificationCode': 'ส่งรหัสยืนยัน',
    'next': 'ต่อไป',
    'prev': 'ก่อนหน้า',
    'finished': 'เสร็จแล้ว',
    'back': 'กลับ',
    'backLogin': 'กลับไปที่การเข้าสู่ระบบ',
    'home': 'เว็บไซต์ทางการระหว่างประเทศ',
    'home_os': 'KEX Express',
    'inquiry': 'สอบถาม',
    'add': 'เพิ่ม',
    'edit': 'แก้ไข',
    'del': 'ลบ',
    'batchDel': 'การลบแบทช์',
    'operating': 'ดำเนินงาน',
    'clearInfo': 'ไม่มีข้อมูล',
    'excelUpload': 'อัปโหลด Excel',
    'serialNumber': 'No.',
    'save': 'บันทึก',
    'leastOne': 'โปรดทำเครื่องหมายข้อมูลที่จะถูกลบ',
    'uploadFile': 'อัปโหลดไฟล์',
    'downloadExcel': 'ดาวน์โหลดเทมเพลต Excel',
    'pleaseInput': 'กรุณาป้อนข้อมูล',
    'pleaseSelect': 'โปรดเลือก',
    'isDel': 'คุณต้องการลบข้อมูลที่เลือกหรือไม่?',
    'agree': 'เห็นด้วย',
    'disagree': 'ไม่เห็นด้วย',
    'uploadTotal': 'จำนวนการอัปโหลดทั้งหมด',
    'uploadSuccess': 'อัปโหลดสำเร็จ',
    'uploadFail': 'การอัพโหลดล้มเหลว',
    'checkAll': 'เลือกทั้งหมด',
    'cancelContent': 'บัญชีนี้ถูกส่งไปยัง [{cancelTime}]สำหรับการยกเลิกและเข้าสู่ระบบเข้าสู่ระบบภายใน 15 วันคุณยังคงลงชื่อเข้าใช้หรือไม่?',
    'ok': 'โอเค',
    'autoTip': 'อยู่ระหว่างการพิจารณา โปรดรอ...',
    'feedback': 'ข้อเสนอแนะ',
    'scanCode': 'สแกนรหัสเพื่อเข้าสู่ระบบ',
    'useWxScan': 'กวาดด้วย WeChat',
    'useWhatsAppScan': 'ใช้การสแกน WhatsApp',
    'otherLoginWays': 'วิธีการเข้าสู่ระบบอื่น ๆ',
    'scanSuccessfully': 'สแกนโค้ดสำเร็จ',
    'confirmOnPhone': 'กรุณายืนยันทางโทรศัพท์',
    'refreshQR': 'คลิกรีเฟรช',
    'consult': 'การให้คำปรึกษาสหกรณ์',
    'please_select_correct_phone': 'โปรดเลือกรหัสพื้นที่โทรศัพท์ที่ถูกต้อง',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'gls',
    'gls_tooltip': 'เคล็ดลับเครื่องมือ'
  },
  'login': {
    'selectLoginType': 'เลือกวิธีการเข้าสู่ระบบ',
    'personal': 'เข้าสู่ระบบแบบส่วนตัว',
    'enterprise': 'เข้าสู่ระบบแบบองค์กร',
    'tel': 'หมายเลขโทรศัพท์',
    'password': 'รหัสผ่าน',
    'verificationCodeLogin': 'เข้าสู่ระบบด้วยรหัสยืนยัน',
    'verificationCode': 'รหัสยืนยัน',
    'obtainVerificationCode': 'ส่งรหัสยืนยัน',
    'passwordLogin': 'เข้าสู่ระบบด้วยรหัสผ่าน',
    'rememberPSD': 'จดจำฉัน',
    'rememberTips': 'ไม่แนะนำสำหรับอุปกรณ์สาธารณะ',
    'forgetPSD': 'ลืมรหัสผ่าน',
    'loginAgree': 'ฉันได้อ่านและยอมรับ',
    'agreeTips': 'นโยบายความเป็นส่วนตัว',
    'epesAcceptableUse': 'นโยบายการใช้บริการ SF Korea ERP',
    'userAgreement': 'ข้อตกลงผู้ใช้',
    'login': 'เข้าสู่ระบบ',
    'username': 'เข้าระบบด้วยชื่อผู้ใช้งาน',
    'email': 'อีเมล',
    'phoneLogin': 'เข้าสู่ระบบด้วยหมายเลขโทรศัพท์มือถือ',
    'usernameLogin': 'เข้าสู่ระบบด้วยชื่อบัญชีผู้ใช้',
    'emailLogin': 'เข้าสู่ระบบด้วยอีเมล',
    'usernameOrEmailLogin': 'เข้าสู่ระบบด้วยชื่อบัญชีผู้ใช้หรืออีเมล',
    'registerNow': 'สมัครเลย',
    'pleaseInput': '',
    'and': ' &',
    'sfbuy_privacy': '《SFBuy Service Agreement(Chinese Mainland)》、《SFBuy Service Agreement(International/HK, MO and TW of China)》',
    'sfbuy_title': 'SFBuy',
    'aboutUs': 'เกี่ยวกับเรา',
    'serviceGuide': 'คู่มือสำหรับมือใหม่',
    'helpCenter': 'ศูนย์ช่วยเหลือ',
    'serviceAndPrice': 'บริการและราคา',
    'onlineCSR': 'ฝ่ายบริการลูกค้าออนไลน์',
    'copyright': 'Copyright  © © สงวนลิขสิทธิ์ เอสเอฟ เอ็กซ์เพรส 2020'
  },
  'register': {
    'personal': 'การลงทะเบียนแบบบุคคล',
    'enterprise': 'การลงทะเบียนแบบองค์กร',
    'tel': 'หมายเลขโทรศัพท์',
    'telVerificationCode': 'รหัสตรวจสอบโทรศัพท์มือถือ',
    'email': 'อีเมล',
    'emailVerificationCode': 'รหัสการยืนยันอีเมล',
    'sendVerificationCode': 'ส่งรหัสยืนยัน',
    // 'password': 'Nhập mật khẩu',
    'password': 'ป้อนรหัสผ่าน',
    'passwordAgain': 'ป้อนรหัสผ่านอีกครั้ง',
    'agree': 'ฉันได้ตกลงกันใน',
    'termsOfService': ' เงื่อนไขการให้บริการ',
    'SFBuyService': 'ข้อตกลงบริการ SFBuy',
    'and': ' &',
    'privacyPolicy': 'นโยบายความเป็นส่วนตัว',
    'registerNow': 'สมัครเลย',
    'haveUserName': 'คุณมีบัญชีอยู่แล้วหรือยัง?',
    'loginNow': 'เข้าสู่ระบบทันที',
    'toEmail': 'การลงทะเบียนอีเมล',
    'toTel': 'การลงทะเบียนโทรศัพท์',
    'invitationCode': 'รหัสการเชิญ',
    'timeCount': '(เหลือ {count}s อ่านจนจบ)',
    'readBottom': '(กรุณาอ่านจนจบ)',
    'isFinshRead': 'กรุณาอ่านและยอมรับเงื่อนไข',
    sfbuy_policy1: '《SFBuy Service Agreement(Chinese Mainland)	》',
    sfbuy_policy2: '《SFBuy Service Agreement(International/HK, MO and TW of China)	》'
  },
  'resetPassword': {
    'resetTel': 'รีเซ็ตโทรศัพท์มือถือ',
    'resetEmail': 'รีเซ็ตอีเมล',
    'tel': 'หมายเลขโทรศัพท์',
    'telVerificationCode': 'รหัสตรวจสอบโทรศัพท์มือถือ',
    'email': 'อีเมล',
    'emailVerificationCode': 'รหัสการยืนยันอีเมล',
    'sendVerificationCode': 'ส่งรหัสยืนยัน',
    'newPassword': 'รหัสผ่านใหม่',
    'confirmNewPassword': 'ยืนยันรหัสผ่านใหม่',
    'resetPassword': 'รีเซ็ตรหัสผ่าน',
    'back': 'กลับ',
    'login': 'เข้าสู่ระบบ',
    'register': 'ลงทะเบียน'
  },
  'modifyPassword': {
    'changePassword': 'แก้ไขรหัสผ่าน',
    'old': 'รหัสผ่านเก่า',
    'new': 'รหัสผ่านใหม่',
    'confirm': 'ยืนยันรหัสผ่านใหม่'
  },
  'cookies': {
    'tip1': 'เว็บไซต์ของเราใช้คุกกี้เพื่อเพิ่มประสิทธิภาพประสบการณ์ผู้ใช้และการวิเคราะห์ เราอาจแบ่งปันข้อมูลของคุณกับพันธมิตรของเรา เพื่อวิเคราะห์ข้อมูล',
    'tip2': 'นโยบายคุกกี้',
    'tip3': 'มีข้อมูลเพิ่มเติม เปลี่ยนการตั้งค่าของคุณ',
    'tip4': 'ที่นี่',
    'tip5': 'โดยคลิกยอมรับว่าคุณยินยอมให้ใช้คุกกี้ของเราตามความต้องการของคุณ',
    'disAgree': 'ปฏิเสธ',
    'cookieSet': 'การตั้งค่าคุกกี้',
    'preference': 'หมวดหมู่ที่ชื่นชอบ',
    'optimisation': 'การเพิ่มประสิทธิภาพ',
    'analytics': 'การวิเคราะห์',
    'neddCheck': 'คุณต้องยอมรับการตั้งค่าก่อน',
    'cookie': 'นโยบายคุกกี้',
    'agree': 'เห็นด้วย',
    'preferenceCenter': 'ศูนย์การตั้งค่า'
  },
  'slideCircus': {
    'title': 'กรุณาตรวจสอบปริศนาด้านล่างให้สมบูรณ์',
    'change': 'เปลี่ยน',
    'right': 'กรุณาเลื่อนไปทางขวา',
    'pass': 'ผ่านการตรวจสอบ',
    'verifyText': 'กรุณากดปุ่มเพื่อการตรวจสอบ',
    'verifying': 'กำลังตรวจสอบปริศนา...',
    'loading': 'กำลังโหลดรูปภาพ'
  },
  'message': {
    'slideError': 'Slider service request failed',
    'selectTerms': 'โปรดตรวจสอบ และใส่เครื่องหมายที่เงื่อนไข',
    'verifyPass': 'กรุณาคลิกที่ปุ่มเพื่อตรวจสอบ',
    'registerSuccess': 'ลงทะเบียนสำเร็จ',
    'sendTips0': 'ส่งสำเร็จ',
    'resetPasswordTips0': 'เปลี่ยนรหัสผ่านสำเร็จ',
    'loginTips0': 'เข้าสู่ระบบสำเร็จ',
    'loginTips1': 'เข้าสู่ระบบสำเร็จ บัญชีเปิดใช้งานแล้ว',
    'modifiedTips0': 'แก้ไขสำเร็จ',
    'switchLanguage': 'เปลี่ยนภาษาสำเร็จ',
    'switchSite': 'เปลี่ยนประเทศได้สำเร็จ',
    'changeTel': 'ยินดีด้วย! หมายเลขโทรศัพท์ของคุณได้รับการแก้ไขเรียบร้อยแล้ว กรุณาเข้าสู่ระบบอีกครั้ง',
    'ChangeEmail': 'ขอแสดงความยินดี, แก้ไขกล่องจดหมายของคุณประสบความสำเร็จ, กรุณาเข้าสู่ระบบอีกครั้ง!',
    'cancelSuccess': 'ยินดีด้วย! บัญชีของคุณถูกยกเลิกได้สำเร็จ',
    'imgType': 'โปรดเลือกรูปภาพอีกครั้ง! การอัปโหลดรองรับ JPG และ PNG เท่านั้น',
    'imgSize': 'โปรดเลือกรูปภาพอีกครั้ง! ขนาดภาพต้องไม่เกิน 3MB',
    'submitSuccess': 'ส่งสำเร็จ',
    'setSuccess': 'ตั้งค่าสำเร็จ',
    'delSuccess': 'ลบสำเร็จ',
    'addSuccess': 'เพิ่มสำเร็จ',
    'fileType': 'โปรดเลือกไฟล์อีกครั้ง! รองรับ xls และ xlsx เท่านั้น ',
    'fileSize': 'โปรดเลือกไฟล์ใหม่ขนาดไฟล์ต้องไม่เกิน 15MB!',
    'delError': 'การลบล้มเหลว โปรดลองอีกครั้งในภายหลัง',
    'uploadFile': 'อัปโหลดไฟล์',
    'uploadFileSuccess': 'อัปโหลดสำเร็จ',
    'selectedOne': 'โปรดกรอกข้อมูลอย่างน้อย',
    'imgTips1': 'อัปโหลดรูปภาพรูปแบบ {imgType}',
    'imgTips2': 'ภาพเดียวจะต้องไม่เกิน 3MB',
    'imgTips3': 'ภาพเดียวจะต้องไม่เกิน 10MB',
    'imgTips4': 'ไม่รองรับการแสดงตัวอย่างไฟล์ PDF',
    'checkProduct': 'กรุณาเลือกสินค้า',
    'clauseAgree': 'โปรดเห็นด้วยกับข้อกำหนดของสัญญาใบนำส่งสินค้าทางอิเล็กทรอนิกส์',
    'estimatedCost': 'กรุณากรอกค่าใช้จ่ายโดยประมาณในแบบฟอร์มบริการเพิ่มเติม',
    'cardCode': 'โปรดป้อนหมายเลขบัตรสำหรับ COD ',
    'threeTips': 'ข้อมูลไม่สมบูรณ์ โปรดตรวจสอบอีกครั้ง',
    'fourTips': 'ข้อมูลการสั่งซื้อไม่สมบูรณ์ โปรดตรวจสอบอีกครั้ง',
    'noNeedUpload': 'ไม่จำเป็นต้องอัปโหลดเอกสารรับรอง',
    'phoneOrFixAtLeastOne': 'หมายเลขโทรศัพท์มือถือ, โทรศัพท์บ้าน กรุณากรอกข้อมูลอย่างน้อย 1 รายการ',
    'customerOrderNo': 'กรุณากรอกหมายเลขการสั่งซื้อของลูกค้า',
    'mas_003038': 'มีความผิดปกติของบัญชีล็อกอินของคุณ โปรดรีเฟรชหน้าเพื่อลองสั่งซื้ออีกครั้ง',
    'mas_003038_HTM': 'มีความผิดปกติในการเข้าสู่ระบบ (หมายเลขโทรศัพท์มือถือ) โปรดรีเฟรชหน้าเพื่อลองสั่งซื้ออีกครั้ง',
    'mas_003035': 'หมายเลขบัญชีของคุณได้รับการลงทะเบียนแล้วโปรดเข้าสู่รายการระหว่างประเทศโดยตรงจาก IOUP',
    'mas_auth_failed': 'ความล้มเหลวในการเรียนรู้'
  },
  'verify': {
    'selectAreaCode': 'กรุณาเลือกประเทศ / รหัสพื้นที่',
    'telTips': 'โปรดกรอกหมายเลขโทรศัพท์มือถือ',
    'telError': 'โปรดกรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
    'companyNameTrue': 'โปรดกรอกชื่อบริษัทที่ถูกต้อง',
    'fixMobileCode': 'กรุณาเลือกรหัสพื้นที่โทรศัพท์บ้าน',
    'fixMobileNumber': 'โปรดกรอกหมายเลขโทรศัพท์พื้นฐาน',
    'fixMobileNumberReg': 'โปรดกรอกหมายเลขโทรศัพท์พื้นฐานที่ถูกต้อง',
    'mobileVerificationCode': 'โปรดกรอกรหัสที่ได้รับบนโทรศัพท์ของคุณ',
    'emailAddress': 'โปรดกรอกอีเมล',
    'emailTips': 'โปรดกรอกอีเมลที่ถูกต้อง',
    'emailVerificationCode': 'โปรดกรอกรหัสการยืนยันอีเมล',
    'password': 'กรุณากรอกรหัสผ่าน',
    'passwordError': 'รหัสผ่าน 8-20 หลักรองรับเฉพาะตัวพิมพ์ใหญ่ตัวเลขและสัญลักษณ์รวมกัน 2 ชนิดขึ้นไป',
    'passwordAgain': 'กรุณากรอกรหัสผ่านอีกครั้ง',
    'passwordNotSame': 'รหัสผ่านไม่ตรงกัน โปรดกรอกอีกครั้ง',
    'usernameTips': 'โปรดกรอกชื่อผู้ใช้งาน',
    'usernameEmailTips': 'โปรดกรอกชื่อผู้ใช้งาน/อีเมล',
    'telEmailTips': 'กรุณากรอกหมายเลขโทรศัพท์มือถือ(ไม่ต้องใช้หมายเลขประเทศ)/กล่องจดหมาย',
    'fixTelEmailTips': 'โปรดป้อนหมายเลขโทรศัพท์มือถือ(ไม่ต้องใช้หมายเลขประเทศ)/กล่องจดหมายที่ถูกต้อง',
    'selectTerms': 'โปรดตรวจสอบ และใส่เครื่องหมายที่เงื่อนไข',
    'accountName': 'รองรับ 6-20 ตัวอักษร ตัวเลข และขีดล่างผสมกัน',
    'verifyType': 'โปรดเลือกวิธีการตรวจสอบ',
    'verifyCode': 'โปรดกรอกรหัสการยืนยัน',
    'lastNameRequired': 'นามสกุลไม่สามารถเว้นว่างได้',
    'firstNameRequired': 'ชื่อไม่สามารถเว้นว่างได้',
    'genderRequired': 'เพศไม่สามารถเว้นว่างได้',
    'birthdayRequired': 'วันเกิดไม่สามารถเว้นว่างได้',
    'certTypeRequired': 'ประเภทของเอกสารยืนยันตัวตนไม่สามารถเว้นว่างได้',
    'certNoRequired': 'หมายเลขเอกสารยืนยันตัวตนไม่สามารถเว้นว่างได้',
    'certExpireDateRequired': 'ระยะเวลาเอกสารยืนยันตัวตนไม่สามารถเว้นว่างได้',
    'notSupTips': 'ไม่รองรับตัวเลข และอักขระพิเศษ',
    'certImage': 'กรุณาอัปโหลดรูปภาพเอกสารยืนยันตัวตนก่อนส่ง',
    'commodityName': 'กรุณากรอกชื่อสินค้า',
    'quantity': 'กรุณากรอกจำนวน',
    'unit': 'กรุณากรอกหน่วย',
    'unitPrice': 'กรุณากรอกราคาต่อหน่วย',
    'placeOfOrigin': 'กรุณาเลือกแหล่งกำเนิด',
    'over0': 'กรุณากรอกตัวเลขมากกว่า 0',
    'decimal3': 'รองรับจุดทศนิยม 3 หลัก',
    'decimal6': 'รองรับจุดทศนิยม 6 หลัก',
    'decimal10': 'รองรับจุดทศนิยม 10 หลัก',
    'productRecordNo': 'โปรดป้อนหมายเลขการยื่นการตรวจสอบระดับชาติที่ถูกต้อง',
    'hsCode': 'โปรดกรอกพิกัดศุลกากรที่ถูกต้อง',
    'productCustomsNo': 'โปรดกรอกหมายเลข EORI ที่ถูกต้อง',
    'contact': 'โปรดกรอกชื่อ',
    'companyName': 'โปรดกรอกชื่อบริษัท',
    'country': 'โปรดเลือกประเทศ/ภูมิภาค',
    'regionFirst': 'กรุณาเลือกจังหวัด เขตเมือง',
    'roadName': 'โปรดกรอกชื่อถนน',
    'buildingNumber': 'โปรดกรอกเลขที่อาคาร',
    'addressDetail': 'โปรดกรอกรายละเอียดที่อยู่',
    'addressDetailTrue': 'โปรดกรอกรายละเอียดที่ี่อยู่ที่ถูกต้อง',
    'postalCode': 'กรุณากรอกรหัสไปรษณีย์',
    'phoneNumber': 'โปรดกรอกหมายเลขโทรศัพท์มือถือ',
    'numberDecimal': 'โปรดกรอกหมายเลข',
    'bangmecho': 'โปรดกรอกที่อยู่',
    'shippingType': 'โปรดเลือกประเภทการจัดส่ง',
    'clearanceInfo': 'โปรดเลือกประเภทเอกสารยืนยันตัวตน',
    'idNumber': 'โปรดกรอกหมายเลขเอกสารยืนยันตัวตน',
    'idNumberIsTrue': 'โปรดกรอกหมายเลขเอกสารยืนยันตัวตนที่ถูกต้อง',
    'contactCn': 'โปรดกรอกชื่อภาษาจีนที่ถูกต้อง',
    'receiveType': 'โปรดเลือกประเภทการรับ',
    'imgNumber': 'อัปโหลดรูปภาพอย่างน้อย {number} รูป',
    'papersTime': 'โปรดเลือกอายุเอกสารยืนยันตัวตน',
    'declaredCurrency': 'โปรดเลือกสกุลเงิน',
    'requred': 'โปรดระบุข้อมูลในช่องนี้',
    'parcelTotalWeight': 'โปรดกรอกน้ำหนักทั้งหมด',
    'contentMaxLength18': 'รองรับจำนวนเต็มสูงสุด 18 ตำแหน่งและทศนิยมสูงสุด 1 ตำแหน่ง',
    'contentIntOrFloatMaxLength': 'รองรับจำนวนเต็มสูงสุด 12 ตำแหน่งและทศนิยมสูงสุด 10 ตำแหน่ง',
    'atLeastSelectTip': 'โปรดเลือกอย่างน้อยหนึ่งรายการ',
    'invitationCode': 'โปรดกรอกรหัสเชิญที่ถูกต้อง',
    'characterLength': 'ความยาวต้องไม่เกิน {length} ตัวอักษร',
    'pickUpTime': 'โปรดเลือกเวลานัดรับพัสดุ',
    'onlyNumberAndLetter': 'รองรับตัวอักษร และตัวเลขผสมกัน',
    'serviceFee': 'ค่าใช้จ่ายโดยประมาณสำหรับบริการเพิ่มเติมรองรับจำนวนเต็ม 12 หลัก และทศนิยม 2 หลัก',
    'methoedCode': 'รองรับหมายเลขบัตรสูงสุด 20 หลัก',
    'contentInt14OrFloat2MaxLength': 'รองรับจำนวนเต็มสูงสุด 14 ตำแหน่งและทศนิยม 2 ตำแหน่ง',
    'contentInt10OrFloat6MaxLength': 'รองรับจำนวนเต็มสูงสุด 10 ตำแหน่งและทศนิยม 6 ตำแหน่ง',
    'contentInt18OrFloat6MaxLength': 'รองรับจำนวนเต็มสูงสุด 18 ตำแหน่งและทศนิยม 6 ตำแหน่ง',
    'timeZoneCode': 'โปรดเลือกเขตเวลา',
    'contentInt14OrFloat1MaxLength': 'รองรับจำนวนเต็มสูงสุด 14 ตำแหน่งและทศนิยม 1 ตำแหน่ง',
    'contentInt15OrFloat5MaxLength': 'รองรับจำนวนเต็มสูงสุด 15 ตำแหน่งและทศนิยม 5 ตำแหน่ง'
  },
  'placeholder': {
    'countryCode': 'กรุณาเลือกประเทศ / รหัสพื้นที่',
    'telCode': 'รหัสพื้นที่',
    'phoneCode': 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
    'mobileVerificationCode': 'โปรดกรอกรหัสที่ได้รับบนโทรศัพท์ของคุณ',
    'verificationCode': 'โปรดกรอกรหัสการยืนยัน',
    'emailAddress': 'โปรดกรอกอีเมล',
    'emailVerificationCode': 'รหัสการยืนยันอีเมล',
    'password': 'กรุณากรอกรหัสผ่าน',
    'checkPassword': 'กรุณากรอกรหัสผ่านอีกครั้ง',
    'enter': 'กรุณากรอก',
    'username': 'ชื่อบัญชีผู้ใช้',
    'cardType': 'โปรดเลือกประเภทเอกสารยืนยันตัวตน',
    'uploadCard': 'ข้อมูลต้องสอดคล้องกับข้อมูลเอกสารยืนยันตัวตน',
    'uploadCardId': 'โปรดกรอกหมายเลขเอกสารยืนยันตัวตน',
    'passwordError': 'รหัสผ่าน 8-20 หลักรองรับเฉพาะตัวพิมพ์ใหญ่ตัวเลขและสัญลักษณ์รวมกัน 3 ชนิดขึ้นไป',
    'passwordAgain': 'กรุณากรอกรหัสผ่านอีกครั้ง',
    'verifyType': 'โปรดเลือกวิธีการตรวจสอบ',
    'newEmail': 'โปรดกรอกอีเมล',
    'addressBook': 'โปรดกรอกชื่อ/ชื่อบริษัท',
    'goodsWarehouse': 'โปรดกรอกชื่อสินค้า/พิกัดศุลกากร',
    'clearanceWaybill': 'กรุณาใส่หมายเลขใบนำส่งสินค้า 12 หลัก หรือหมายเลขใบนำส่งสินค้า 15 หลักที่ขึ้นต้นด้วย \\#SF\\#',
    'parcelTotalLength': 'โปรดกรอกความยาว',
    'parcelTotalWidth': 'โปรดกรอกความกว้าง',
    'parcelTotalHeight': 'โปรดกรอกความสูง',
    'senderReason': 'โปรดเลือกวัตถุประสงค์ในการส่ง',
    'tradeCondition': 'โปรดเลือกเงื่อนไขการซื้อขาย',
    'senderReasonContent': 'โปรดกรอกวัตถุประสงค์ในการส่งที่ไม่ใช่เชิงพาณิชย์',
    'businessRemark': 'โปรดกรอก Commercial Invoice ในช่องหมายเหตุ',
    'pickupAppointTime': 'โปรดเลือกวัน และเวลา (เวลารับภายใน 3 ชั่วโมงหลังได้รับการนัดหมาย)',
    'remarkText': 'โปรดกรอกข้อความของคุณ',
    'payMethod': 'โปรดเลือกวิธีการชำระเงิน',
    'payMonthCard': 'โปรดกรอกหมายเลขบัญชีรายเดือน',
    'taxPayMethod': 'โปรดเลือกวิธีการชำระภาษี',
    'taxPayMonthCard': 'โปรดกรอกเลขที่บัญชีชำระภาษี',
    'serviceFee': 'โปรดกรอกค่าธรรมเนียมโดยประมาณ',
    'feeCard': 'โปรดกรอกหมายเลข COD',
    'invitationCode': 'โปรดกรอกรหัสคำเชิญลงทะเบียน/VIP',
    'willBay': 'โปรดกรอกหมายเลขติดตามพัสดุ',
    'senderCountry': 'โปรดเลือกแหล่งกำเนิด',
    'receiverCountry': 'โปรดเลือกปลายทาง',
    'receiverContact': 'โปรดกรอกชื่อผู้รับ',
    'orderStatus': 'โปรดเลือกสถานะการสั่งซื้อ',
    'startTime': 'วันที่เริ่ม',
    'to': 'ถึง',
    'endTime': 'วันที่สิ้นสุด',
    'timeZoneCode': 'โปรดเลือกเขตเวลา'
  },
  'tagsView': {
    'refresh': 'รีเฟรช',
    'close': 'ปิด',
    'closeOthers': 'ใกล้เคียงกัน',
    'closeAll': 'ปิดทั้งหมด'
  },
  'exit': {
    'title': 'ออกจากระบบ',
    'message': 'คุณแน่ใจว่าต้องการออกจากระบบ?',
    'success': 'ออกจากระบบสำเร็จ',
    'cancel': 'ยกเลิกการออกจากระบบ',
    'close': 'ยกเลิกสำเร็จ'
  },
  'notFind': {
    'oops': '404',
    'info': 'ขออภัย หน้าที่คุณเยี่ยมชมไม่มีอยู่',
    'backHome': 'กลับหน้าแรก'
  },
  'settings': {
    'title': 'ศูนย์บริการรับรองมาตรฐานสากล'
  },
  'role': {
    'admin': 'ผู้ดูแลระบบ',
    'user': 'ผู้ใช้งานทั่วไป'
  },
  'route': {
    'Login': 'เข้าสู่ระบบ',
    '顺丰国际产品导航': 'Product Navigation',
    'Register': 'ลงทะเบียน',
    'ResetPassword': 'คุณลืมรหัสผ่านหรือไม่?',
    'UserCenter': 'ข้อมูลส่วนตัว',
    'MyInfomation': 'ข้อมูลของฉัน',
    'AccountInfomation': 'ข้อมูลเกี่ยวกับบัญชี',
    'BaseInfomation': 'ข้อมูลพื้นฐาน',
    'AccountSecurity': 'ความปลอดภัยของบัญชี',
    'ProtocolManage': 'การจัดการลงนาม',
    'AccountSetting': 'การตั้งค่าบัญชี',
    'BindingEmail': 'ผูกกับอีเมล',
    'BindingPhone': 'ผูกกับเบอร์โทรศัพท์มือถือ',
    'CancelAccount': 'ยกเลิกบัญชี',
    'ChangeEmail': 'แก้ไขอีเมล',
    'ChangePassword': 'แก้ไขรหัสผ่าน',
    'ChangePhone': 'เปลี่ยนหมายเลขโทรศัพท์',
    'Name': 'ตั้งชื่อผู้ใช้งาน',
    'ToMail': 'ส่งพัสดุ',
    'MailProduct': 'บริการ',
    'AddressBook': 'สมุดที่อยู่',
    'GoodsWarehouse': 'คลังบทความ',
    'Order': 'การจัดการคำสั่งซื้อ',
    'OrderIndex': 'รายการสั่งซื้อ',
    'OrderAdd': 'คำสั่งซื้อแบบจัดส่งรายการดียว',
    'Clearance': 'ข้อมูลพิธีการศุลกากร',
    'UploadPhotoid': 'อัปโหลดเอกสารยืนยันตัวตน',
    'EditOrder': 'แก้ไขคำสั่งซื้อ',
    'permission': 'การจัดการสิทธิ์',
    'permission_system': 'การจัดการระบบ',
    'permission_role': 'การจัดการบทบาท',
    'permission_resource': 'การอนุญาตทรัพยากร',
    'permission_user': 'การจัดการผู้ใช้'
  },
  'button': {
    'sumbit': 'ส่ง'
  },
  'accountInfo': {
    'username': 'ชื่อผู้ใช้งาน',
    'firstname': 'ชื่อ',
    'lastname': 'นามสกุล',
    'sex': 'เพศ',
    'man': 'ชาย',
    'woman': 'หญิง',
    'telNumber': 'หมายเลขโทรศัพท์มือถือ:',
    'telNumberNot': 'บัญชีของคุณไม่ได้เชื่อมกับหมายเลขโทรศัพท์มือถือ',
    'email': 'อีเมล',
    'emailNot': 'บัญชีของคุณไม่ได้เชื่อมกับอีเมล',
    'binding': 'เชื่อมต่อทันที',
    'changeTel': 'เปลี่ยนหมายเลขโทรศัพท์',
    'changeEmail': 'แก้ไขอีเมล',
    'validated': 'ตรวจสอบแล้ว',
    'autoGeneration': 'สร้างโดยอัตโนมัติ',
    'usernameTips': 'ชื่อผู้ใช้งานไม่สามารถเปลี่ยนแปลงได้หลังตั้งค่า',
    'birthday': 'วันเกิด',
    'birthday1': 'วันเกิด',
    'autoCreate': 'สร้างโดยอัตโนมัติ'
  },
  'baseInfo': {
    'cardType': 'ประเภทเอกสารยืนยันตัวตน',
    'firstname': 'ชื่อ',
    'lastname': 'นามสกุล',
    'cardId': 'หมายเลขเอกสารยืนยันตัวตน',
    'cardTime': 'อายุเอกสารยืนยันตัวตน',
    'cardImg': 'รูปภาพของเอกสาร: ',
    'cardLangTime': 'ตลอดชีพ',
    'uploadImg': 'อัปโหลดรูปภาพ',
    'titleTips': 'หมายเหตุ: ต้องใช้ชื่อจริงในการส่งพัสดุระหว่างประเทศ และใช้สำหรับพิธีการศุลกากร ข้อมูลเอกสารการยืนยันตัวตนจะถูกตั้งค่าด้วยลายน้ำพิเศษ และ SF Express จะรับรองความปลอดภัยข้อมูลของคุณ',
    'dialogTitle': 'ตัวอย่างมาตรฐาน',
    'dialogTips': 'เอกสารยืนยันตัวตนที่อัปโหลดควรมีทั้งสี่มุม ข้อความชัดเจน ไม่มีการบดบัง หากเบลอและมืดเกินไป การตรวจสอบอาจล้มเหลว!',
    'cardUp': 'ด้านหน้าเอกสารยืนยันตัวตน',
    'cardDown': 'ด้านหลังเอกสารยืนยันตัวตน'
  },
  'emailLink': {
    'tips': 'กรุณาตั้งค่ารหัสผ่าน',
    'setPassword': 'ตั้งรหัสผ่าน',
    'success': 'บัญชีเปิดใช้งานสำเร็จ'
  },
  'accountSecurity': {
    'ChangePassword': 'แก้ไขรหัสผ่าน',
    'ChangePasswordDesc': 'หากคุณไม่ได้เข้าสู่ระบบเป็นเวลานานและลืมรหัสผ่าน คุณสามารถเปลี่ยนรหัสผ่านได้หลังจากยืนยันตัวตนของคุณแล้ว',
    'BindingPhone': 'ผูกกับเบอร์โทรศัพท์มือถือ',
    'BindingPhoneDesc': 'คุณสามารถเข้าสู่ระบบ ดึงรหัสผ่าน การสั่งซื้อ และบริการอื่นๆ ได้ด้วยหมายเลขโทรศัพท์มือถือที่เชื่อม',
    'BindingEmail': 'ผูกกับอีเมล',
    'BindingEmailDesc': 'คุณสามารถเข้าสู่ระบบ ดึงรหัสผ่าน การสั่งซื้อ และบริการอื่นๆ ได้ด้วยอีเมลที่เชื่อม',
    'SettingName': 'ตั้งค่าชื่อผู้ใช้',
    'SettingNameDesc': 'สามารถใช้ชื่อผู้ใช้งานในการเข้าสู่ระบบ และไม่สามารถเปลี่ยนแปลงได้',
    'SettingRealName': 'ตั้งค่าชื่อแรกและชื่อล่าสุด',
    'SettingRealNameDesc': 'การตั้งค่าข้อมูลชื่อส่วนบุคคลที่มีอยู่เป็นทรัพย์สินหมายเลขบัญชีที่สามารถแก้ไขได้หลายครั้ง',
    'immediatelySet': 'ตั้งค่าทันที',
    'alreadySet': 'ตั้งค่าแล้ว',
    'settingComplete': 'การตั้งค่าเสร็จสมบูรณ์',
    'alreadyBinding': 'เชื่อมแล้ว',
    'userName': 'ชื่อผู้ใช้งาน',
    'userNameLogin': 'ชื่อผู้ใช้งานไม่สามารถเปลี่ยนแปลงได้หลังตั้งค่า',
    'selfCreate': 'สร้างโดยอัตโนมัติ',
    'stopEdit': 'ชื่อผู้ใช้งานไม่สามารถเปลี่ยนแปลงได้หลังตั้งค่า',
    'setOk': 'ตั้งค่าเสร็จสมบูรณ์',
    'cancelAccount': 'การยกเลิกบัญชี',
    'cancelAccountTips': 'โปรดทราบว่าข้อมูลไม่สามารถกู้คืนได้หลังจากยกเลิก',
    'toCancel': 'ยกเลิกทันที',
    'cancelToKnow': 'ข้อตกลงการออกจากบัญชี',
    'cancelDesc1': 'บัญชีที่สมัครใช้งานบน SF International หากมีการยกเลิกแก้ไปเปลี่ยนแปลงข้อมูลในระบบSF Internationalแล้วนั้นจะไม่สามารถใช้งานได้ต่อ เพราะฉะนั่นกรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง',
    'cancelDesc2': 'การสมัครขอยกเลิกบริการ สมาชิคกับทางSF International โดยความยินยอม(คูปอง,ส่วนลด ,สิทะฺพิเศษต่างๆ จะไม่สามารถนำมาใช้งานได้)',
    'cancelDesc3': '3.หลังจากยกเลิกแอคเค้าท์จะไม่สามารถเข้าระบบเพื่อค้นหาข้อมูลบัญชีนั้นได้อีก เพราะฉะนั้นข้อมูล AWB สามารถตรวจสอบได้ที่หน้าเวปเว็ปไซต์ SF ',
    'cancelDesc4': '4.หากคุณเปิดใช้งานบัญชีแอคเค้าท์,หลังจากยกเลิกแอคเค้าท์ใช้งาน ,บัญชีจะถูกยกเลิกผูกผู้ใช้ในระบบ เพราะแะนั้นจะต้องดำเนินการสมัครสมาชิกใหม่ ',
    'cancelDesc5': '5.การยกเลิกบัญชีใช้งาน จะไม่สามารถยกเลิกยอดค้างชำระการใช้งานไปด้วยได้',
    'cancelDesc6': '6.การยกเลิกในระบบ สามารถทำได้ภายใน15วัน ในระยะเวลา 15วัน หากต้องการใช้งานในระหว่างที่ยกเลิกบริการผู้ใช้สามารถสมัครเข้าระบบใหม่',
    'cancelAgree': 'ฉันได้อ่านและยอมรับข้อตกลงการยกเลิกหมายเลขบัญชี',
    'cancelTitle': 'ออกจากระบบบัญชี',
    'cancelConfirm': 'ยืนยันที่จะยกเลิกบัญชี เดี๋ยวนี้',
    'cancelTips': 'กรุณาอ่านข้อกำหนดและยืนยันการยกเลิกบัญชี',
    'goBinding': 'เชื่อมต่อทันที',
    'changeBinding': 'เปลี่ยนการเชื่อมต่อทันที',
    'auth': 'การตรวจสอบตัวตน',
    'finish': 'แก้ไขสมบูรณ์',
    'binding': 'การเชื่อมต่อสำเร็จ',
    'verifyType': 'การระบุตัวตน',
    'ChangePhone': 'เปลี่ยนหมายเลขโทรศัพท์',
    'ChangeEmail': 'แก้ไขอีเมล',
    'tips1': 'ยินดีด้วย การเปลี่ยนรหัสผ่านของคุณสำเร็จ',
    'tips2': 'ยินดีด้วย การเปลี่ยนเบอร์โทรศัพท์ของคุณสำเร็จ',
    'tips3': 'ยินดีด้วย การเปลี่ยนอีเมลของคุณสำเร็จ',
    'tips4': 'ยินดีด้วย หมายเลขโทรศัพท์ของคุณเชื่อมโยงเรียบร้อย',
    'tips5': 'ยินดีด้วย หมายเลขอีเมลของคุณเชื่อมโยงเรียบร้อย',
    'tips6': 'ยินดีด้วย รายชื่อของคุณตั้งค่าเรียบร้อย',
    pleaseFirst: 'ขอก่อนนะคะ',
    or: 'หรือ',
  },
  'accountConflict': {
    'title': 'การยืนยันบัญชี',
    'desc1': 'เรียน ลูกค้า',
    'desc2': 'ระบบตรวจพบว่ากล่องจดหมาย/โทรศัพท์มือถือของคุณได้ลงทะเบียนหลายระบบ </br> เพื่อปรับปรุงประสบการณ์โปรดเลือกบัญชีล็อกอินใดบัญชีหนึ่งเป็นบัญชีเข้าสู่ระบบแบบครบวงจรสำหรับหลายระบบ',
    'desc3': 'หลังจากคลิก "ยืนยัน"ระบบจะส่งลิงค์รหัสผ่านแก้ไขไปยังกล่องจดหมาย/โทรศัพท์มือถือของคุณ โปรดทำงานตามพรอมต์และเก็บไว้อย่างถูกต้อง',
    'loginName': 'ชื่อผู้ใช้งาน',
    'phone': 'โทรศัพท์มือถือ',
    'registerSys': 'ระบบลงทะเบียน',
    'registerTime': 'เวลาลงทะเบียน',
    'newRegister': 'ลงทะเบียนใหม่',
    'infoVer': 'ยืนยันข้อมูล',
    'inforVerSelect': 'โปรดเลือกวิธีการยืนยันของคุณ',
    'selectOne': 'โปรดเลือกบัญชีล็อกอินใดบัญชีเดียว',
    'IBS': 'ระบบการจัดการคำสั่งซื้อในต่างประเทศ',
    'ICAS': 'ระบบบัญชีลูกค้าต่างประเทศ',
    'IUOP': 'แพลตฟอร์มการสั่งซื้อแบบครบวงจรระหว่างประเทศ',
    'IBSE': 'ระบบธุรกิจระหว่างประเทศส่งออก',
    'PMS': 'ระบบธุรกิจระหว่างประเทศนำเข้า',
    'IBSI': 'ธุรกิจระหว่างประเทศ โลจิสติกส์ นำเข้า',
    'SFBUY': 'SFBUY',
    'POP': 'แพลตฟอร์มพันธมิตร',
    'SFGOAPP': 'SF GO',
    'IFTP': 'แพลตฟอร์มการขนส่งสินค้าระหว่างประเทศ',
    'OFTP': 'แพลตฟอร์มขนส่งสินค้าในต่างประเทศ'
  },
  'permission': {
    'reset': 'รีเซ็ต',
    'enable': 'เปิดใช้',
    'disable': 'ปิดการใช้งาน',
    'delete': 'ลบ',
    'deleteBatch': 'ลบแบทช์',
    'remark': 'หมายเหตุ',
    'sort': 'เรียงลำดับ',
    'confirm': 'ยืนยัน',
    'cancel': 'ยกเลิก',
    'operation': 'การดำเนินงาน',
    'modify': 'การปรับเปลี่ยน',
    'select': 'กรุณาเลือก',
    'input': 'กรุณาใส่ชื่อผู้ใช้หรือหมายเลข',
    'query': 'สอบถาม',
    'edit': 'แก้ไข',
    'required_rule': 'ข้อมูลไม่สามารถว่างเปล่าได้',
    'success': 'ความสำเร็จในการดำเนินงาน',
    'fail': 'การดำเนินการล้มเหลว',
    'length_rule': 'ความยาวใน {min} ถึง {max} ตัวอักษร',
    'deleteTip1': 'โปรดปิดใช้งานระบบย่อยทั้งหมดภายใต้ "{name}"ก่อน',
    'deleteTis': 'คุณยืนยันการลบรายการข้อมูลที่มีชื่อว่า "{name}"หรือไม่?',
    'deleteChildTis': 'ขณะที่ระบบทั้งหมดภายใต้ระบบนี้จะถูกลบออก',
    'tis': 'เคล็ดลับ',
    'deleteBatchTis': 'ยืนยันการลบข้อมูลแถบ {num} ที่เลือก?',
    'enableTis': 'ยืนยันข้อมูลแถบ {num} ที่เลือกโดย {statusName}?',
    'msgError': 'ข้อมูลการดำเนินงานผิดพลาด',
    'codeCheckRule': 'อนุญาตให้ใช้ตัวพิมพ์ใหญ่ ตัวเลข "_"หรือ "-"',
    'checkMinCharacter': 'โปรดป้อน {min} ตัวอักษรมากกว่า',
    'roleType_0': 'บทบาทการสร้างตนเอง',
    'roleType_1': 'ผู้ดูแลระบบ',
    'bindResource': 'เชื่อมโยงทรัพยากร',
    'roleList': 'รายการบทบาท',
    'roleAdd': 'เพิ่มบทบาท',
    'roleEdit': 'แก้ไขบทบาท',
    'roleConfig': 'ปรับแต่งบทบาท',
    'childSystemName': 'ชื่อระบบย่อย',
    'roleNo': 'หมายเลขบทบาท',
    'roleName': 'ชื่อตัวละคร',
    'roleDescribe': 'คำอธิบายบทบาท',
    'isSystem': 'ระบบที่สังกัด',
    'roleType': 'ประเภทบทบาท',
    'userStatus_0': 'ยังไม่ได้เปิดใช้งาน',
    'userStatus_1': 'เปิดใช้งานแล้ว',
    'userStatus_2': 'ออกจากระบบก่อน',
    'userStatus_3': 'ออกจากระบบแล้ว',
    'userStatus_4': 'ปิดการใช้งาน',
    'userStatus_5': 'ล็อค',
    'userRoleEdit': 'ดู/แก้ไขบทบาท',
    'userList': 'รายชื่อผู้ใช้',
    'regtime': 'เวลาลงทะเบียน',
    'userCode': 'หมายเลขผู้ใช้',
    'area': 'เขตพื้นที่',
    'nickName': 'ชื่อเล่น',
    'sourceSystem': 'ระบบแหล่งที่มา',
    'userStatus': 'สถานะ',
    'systemList': 'รายชื่อระบบ',
    'systemAdd': 'เพิ่มระบบ',
    'systemModify': 'แก้ไขระบบ',
    'systemName': 'ชื่อระบบ',
    'systemType': 'ประเภทของระบบ',
    'systemType_0': 'ข้อมูลหลัก',
    'systemType_1': 'ระบบธุรกิจ',
    'systemCode': 'การเข้ารหัสระบบ',
    'systemStatus': 'สถานะของระบบ',
    'systemStatus_0': 'เปิดใช้',
    'systemStatus_1': 'ปิดการใช้งาน',
    'systemAddChildren': 'เพิ่มระบบย่อย',
    'systemSuperior': 'ระบบเหนือกว่า',
    'resourceList': 'รายการทรัพยากร',
    'resourceAdd': 'เพิ่มทรัพยากร',
    'resourceModify': 'แก้ไขทรัพยากร',
    'resourceName': 'ชื่อทรัพยากร',
    'resourceType': 'ประเภทของทรัพยากร',
    'resourceType_MENU': 'เมนู',
    'resourceType_MODULE': 'แคตตาล็อก',
    'resourceType_WIDGET': 'ปุ่มกด',
    'resourceCode': 'การเข้ารหัสทรัพยากร',
    'resourceStatus': 'สถานะทรัพยากร',
    'resourceStatus_true': 'เปิดใช้',
    'resourceStatus_false': 'ปิดการใช้งาน',
    'resourceAddChildren': 'เพิ่มรายการย่อย',
    'resourceSuperior': 'เมนูขั้นสูง',
    'icon': 'รูปแบบไอคอน',
    'iconActive': 'ไอคอนที่ใช้งานอยู่',
    'shortName': 'ชื่อย่อ',
    'resourceUrl': 'URL ทรัพยากร',
    'resourceFun': 'URL คุณสมบัติ',
    'openType': 'วิธีการเปิด',
    'openType_0': 'การกำหนดเส้นทางหน้า',
    'openType_1': 'หน้าต่างใหม่',
    'pub': 'ไม่ว่าจะเป็นการควบคุมสิทธิ์ที่จำเป็น',
    'pub_true': 'ใช่',
    'pub_false': 'ไม่',
    'hidden': 'ซ่อนหรือไม่',
    'hidden_0': 'ใช่',
    'hidden_1': 'ไม่',
    'selectSystem': 'โปรดเลือกระบบก่อน'
  },
  'protocol': {
    'num': 'หมายเลข',
    'protocolName': 'ชื่อโปรโตคอล',
    'protocolNo': 'หมายเลขรุ่นโปรโตคอล',
    'signTime': 'เวลาลงนาม',
    'remark': 'หมายเหตุ',
    'signUser': 'ลงชื่อเข้าใช้บัญชี',
    'signName': 'เซ็นชื่อลูกค้า',
    'signChild': 'หมายเลขรุ่นย่อยของโปรโตคอล'
  },
  'sfbuy': {
    'wechatScane': 'WeChat กวาด',
    'wechatScane1': 'การเรียนรู้ในเวลาที่เหมาะสม',
    'wechatScane2': 'WeChat แบบไดนามิก',
    'onlineService': 'ฝ่ายบริการลูกค้าออนไลน์',
    'aboutUs': 'เกี่ยวกับเรา',
    'serviceGuide': 'คู่มือสำหรับมือใหม่',
    'helpCenter': 'ศูนย์ช่วยเหลือ',
    'serviceAndPrice': 'บริการและราคา',
    'announcement': 'ประกาศ',
    'important': 'สำคัญ'
  },
  messageNotice: {
    'yxDetail': 'รายละเอียด',
    'optional': 'ไม่จำเป็น',
    'loginXyAgree': 'ฉันยอมรับการแจ้งเตือนเกี่ยวกับการตลาดและการโฆษณา',
    messageNotice: 'การแจ้งเตือนข้อความ',
    messageNoticeDesc: 'รองรับการปรับแต่งการแจ้งเตือน',
    messageNoticeBtn: 'แก้ไขการกำหนดค่า',
    messageNoticeTitle: 'การตั้งค่าการแจ้งเตือนการตลาด',
    messageNoticeTitleDesc1: 'ดู',
    messageNoticeTitleDesc2: 'การเก็บข้อมูลส่วนตัว การเลือกหมายถึงยินยอมรับการตลาดและโฆษณา',
    messageNoticeDetailTitle: 'รายละเอียดข้อมูลการแจ้งเตือนการตลาด',
    message: 'ข้อความ SMS',
    messageNotcieDialogTitle: 'การกำหนดช่องทางการตลาด',
    considerLater: 'จะพิจารณาในภายหลัง',
    messageNotcieDialogDesc1:
    'การคลิกปุ่มยืนยันหมายความว่าคุณยินยอมให้เราใช้ช่องทางต่อไปนี้เพื่อส่งการตลาดและโฆษณาที่คุณอาจสนใจให้คุณ ​',
    messageNotcieDialogDesc2: 'การเก็บรวบรวมข้อมูลส่วนบุคคลโปรดดูที่รายละเอียด',
    messageNotcieDialogDetail: 'รายละเอียด',
  },
  weakPassword: {
    提示: 'คำแนะนำ',
    账号异常提醒: 'บัญชีของคุณมีกิจกรรมผิดปกติ โปรดเปลี่ยนรหัสผ่านหรือใช้รหัสยืนยัน/สแกน QR code เพื่อเข้าสู่ระบบ',
    修改密码: 'เปลี่ยนรหัสผ่าน',
    关闭: 'ปิด',
    账号异常处理: 'การจัดการบัญชีผิดปกติ',
    绑定提示: 'โปรดลงทะเบียนมือถือหรืออีเมลก่อน แล้วจึงเปลี่ยนรหัสผ่าน',
    账号: 'บัญชี'
  },
  recommendedPassword: {
    使用推荐密码: 'ใช้รหัสผ่านที่แนะนำ',
    提示: 'หมายเหตุ',
    请保管好您的密码: 'กรุณารักษารหัสผ่านของคุณให้ปลอดภัย ขอแนะนำให้เปลี่ยนรหัสผ่านทันทีหลังจากเข้าสู่ระบบ',
    复制密码: 'คัดลอกรหัสผ่าน',
    psd: 'รหัสผ่าน',
    copySuccess: 'คัดลอกสำเร็จ',
    注册成功: 'ขอแสดงความยินดีในการลงทะเบียนสำเร็จ!',
    注册建议: 'เพื่อความปลอดภัยของบัญชี แนะนำให้ไปที่ "ศูนย์กลางการจัดการ - การตั้งค่าบัญชี" เพื่อเปลี่ยนรหัสผ่านของคุณ',
    修改密码: ''
  },
  twoFactorAuth: {
    双因素认证: 'การยืนยันสองปัจจัย',
    认证方式: 'วิธีการรับรองความถูกต้อง',
    为了您的账号安全: 'เพื่อความปลอดภัยของบัญชีคุณ โปรดยืนยันตัวตนสองขั้นตอนให้เสร็จสิ้นก่อนเข้าสู่ระบบ',
    请选择绑定: 'กรุณาเลือกเพื่อเชื่อมโยง:',
    请先设置您的密码: 'กรุณาตั้งรหัสผ่านของคุณก่อน'
  },

  sendType: {
    您当前手机区号不支持whatsapp:
      'รหัสพื้นที่มือถือปัจจุบันของคุณไม่รองรับ {noticeChanel} โปรดเลือกวิธีอื่นในการรับรหัสยืนยัน',
    请使用绑定手机号接收验证码: 'กรุณาใช้เบอร์โทรศัพท์ที่ลงทะเบียนไว้รับรหัสยืนยัน',
    请使用绑定邮箱接收验证码: 'กรุณาใช้อีเมลที่ลงทะเบียนไว้รับรหัสยืนยัน',
    请选择验证码接收方式: 'โปรดเลือกวิธีการรับรหัสยืนยัน',
  },
  recommendFloat: {
    '满意度评价': 'การประเมินความพึงพอใจ',
    '您的评价对我们很重要': 'ความคิดเห็นของคุณมีความสำคัญต่อเรามาก',
    '我要评价': 'ฉันต้องการประเมิน'
  }
}
